import type { FC } from 'react';
import type { TChatMessageProps } from '@components/Molecules/Chat/Chat.types';
import classNames from 'classnames';
import { Avatar } from '@reverse-hr/design-system';
import { useTranslation } from 'react-i18next';

export const ChatMessage: FC<TChatMessageProps> = ({ message }) => {
  const { t } = useTranslation('', {
    keyPrefix: 'candidateDetails.chat.message',
  });

  const wrapperClassNames = classNames('ev-chat__message', {
    'ev-chat__message--head-hunter': message.isAuthorHeadHunter,
  });

  return (
    <div className={wrapperClassNames}>
      <p className="ev-chat__message-heading">
        {t('heading', {
          authorFullName: message.authorFullName,
          date: new Date(message.leftAt),
        })}
      </p>

      <Avatar
        className="ev-chat__message-avatar"
        size={56}
        src={message.authorAvatar || undefined}
      />

      <p className="ev-chat__message-content">{message.content}</p>
    </div>
  );
};
